import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { css } from 'styled-components';
import UserContext from '../../hooks/UserContext';
import Api from '../../utils/Api';
import toast from 'react-hot-toast';
import accountStyles from './account-styles';
import Title from '../../components/Account/Title';
import ConfirmButton from '../../components/ConfirmButton';

const styles = css`
${accountStyles}

.profile {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
.form {
  max-width: 500px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: left;
  & input {
    width: 100%;
  }
}
.controls {
  display: flex;
  align-self: end;
  gap: 1em;
  margin-right: 30px;
}
.delete-account {
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  justify-content: center;
  text-align: center;
  font-weight: bold;
  text-transform: uppercase;
}
.welcome {
  font-size: 2em;
  align-self: center;
}
`
const Profile = ({ className }) => {

  const { user, updateUser } = useContext(UserContext);
  const [firstname, setFirstname] = useState(user?.firstname);
  const [lastname, setLastname] = useState(user?.lastname);
  const [phone, setPhone] = useState(user?.phone)
  const [address, setAddress] = useState(user?.address);
  const navigate = useNavigate();

  const handleDeleteAccount = async () => {
    const [error] = await Api.deleteMe();
    if (error) {
      toast.error(`Error deleting account: ${Api.error(error)}`);
      console.error(error);
    } else {
      navigate('/login');
    }
  }

  const submit = async e => {
    e.preventDefault();
    const [err, newUser] = await Api.updateProfile({
      firstname,
      lastname,
      phone,
      address,
    });
    if (err) {
      toast.error(`Error saving profile: ${Api.error(err)}`);
      console.error(err);
    } else {
      toast.success('Profile updated successfully')
      updateUser(newUser);
    }
  }

  return (
    <div className={className}>
      <Title title='Profile' />
      <div className='profile'>
        <div className='form'>
          <input placeholder='First Name' value={firstname} onChange={e => setFirstname(e.target.value)} />
          <input placeholder='Last Name' value={lastname} onChange={e => setLastname(e.target.value)} />
          <input placeholder='Phone' value={phone} onChange={e => setPhone(e.target.value)} />
          <input placeholder='Address' value={address} onChange={e => setAddress(e.target.value)} />
        </div>
      </div>
      <button className='primary' onClick={submit}>Save</button>
      <div className='delete-account'>
        <ConfirmButton
          className='danger'
          text={"Deleting your account will remove all lists you've created, and will remove you from all groups.  You will have to be invited back into the app again to use it. Are you sure?"}
          confirm='Yes'
          cancel='No'
          onConfirm={handleDeleteAccount}
          onCancel={() => { }}>
          Delete Account!
        </ConfirmButton>
        <div>
          By deleting your account, you understand that all groups, lists,
          items, likes, and any other content that you have created will be
          permanently deleted
        </div>
      </div>

    </div >
  )
}

export default styled(Profile)`${styles}`;